export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7078.ff5b1842.jpg";